import { useHistory } from 'react-router-dom'
import { useMount } from 'react-use'
import queryString from 'query-string'
import { getModalUrl } from 'lib/modals'
import { deleteLocationSearchParam } from 'lib/location'

/**
 * Check if we have query parameter set in url to prompt user to sync strong identification name with account name.
 *
 * Deletes the query parameter and opens modal.
 */
const useSyncIdentificationPrompt = () => {
    const history = useHistory()

    useMount(() => {
        const queryParams = queryString.parse(history.location.search)
        if (typeof queryParams['prompt-sync-identification-name'] !== 'undefined') {
            const newLocation = deleteLocationSearchParam(history.location, 'prompt-sync-identification-name')
            history.replace(getModalUrl(newLocation, 'kayttaja/yhdenmukaista-tiedot'))
        }
    })
}

export default useSyncIdentificationPrompt
